import { TInitialState } from "./contextTypes";

export const initialState: TInitialState = {} as TInitialState;